import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Component, forwardRef, Input } from '@angular/core';

import { PasswordSharedComponent } from '../../molecules/password/password.component';

import { PasswordStrength } from '../../../shared/helpers/utilities/password-strength';

export const INPUT_CUSTOM_INPUT_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    // tslint:disable-next-line:no-forward-ref no-use-before-declare
    useExisting: forwardRef(() => PasswordStrengthSharedComponent),
    multi: true
};

@Component({
    selector: 'mlp-ng-password-strength',
    templateUrl: './password-strength.component.html',
    styleUrls: ['./password-strength.component.scss'],
    providers: [
        INPUT_CUSTOM_INPUT_ACCESSOR
    ]
})

export class PasswordStrengthSharedComponent extends PasswordSharedComponent implements ControlValueAccessor {
    // tslint:disable-next-line:no-input-rename
    @Input('value') _value = '';
    @Input() showStrengthBar = false;
    passwordStrength = new PasswordStrength();

    strength = 0;

    onChange: any = () => {};
    onTouched: any = () => {};

    get value(): any { return this._value; }
    set value(val) {
        this.strength = this.passwordStrength.calculate(val);
        this._value = val;
        this.onChange(val);
        this.onTouched();
    }

    writeValue(value): void {
        this.value = value;
    }

    registerOnChange(fn): void {
        this.onChange = fn;
    }

    registerOnTouched(fn): void {
        this.onTouched = fn;
    }

    // articulate: articulate a value using expressions in array
    // 0 - 25: use first word
    // 25 - 75: use second word
    // 75 - 100: use third word
    articulate(value: number, expressions: Array<string>): string {
        if (value > 25 && value <= 75) {
            return expressions[1];
        }

        if (value > 75) {
            return expressions[2];
        }

        return expressions[0];
    }
}
